if($('header#header').length){
    $('.top-navigation-contacts').prepend($('footer#footer .showroomTop'))
    $('.top-navigation-bar a.login').after('<a href="/registrace/" class="registration">Registrace</a>')
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools')
    $('.top-navigation-tools .dropdown').clone().appendTo('.responsive-tools')
    $('.header-top').append($('.top-navigation-bar .responsive-tools'))
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">Uživatelské jméno nebo e-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">Heslo<span>*</span></label>')  
    $('<span class="close"></span>').appendTo('.popup-widget-inner');
    $('nav#navigation .menu-image img').each(function(){
        if($(this).attr('data-src')){
            $(this).attr('data-src', $(this).attr('data-src').replace('thumb', 'orig'))
            $(this).attr('src', $(this).attr('data-src'))
        }
       
    })
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    }) 
      

    function checkAndDisplaySVG(url, container) {
        var svgName = url.replace(/\//g, '');
        var svgUrl = '/user/documents/upload/menu-images/' + svgName+'.svg';
        var img = new Image();
        img.onload = function() {
            $(container).html(img);
        };
        img.onerror = function() {
        };
        img.src = svgUrl; 
    }
    $('.menu-level-1>li>a').each(function(){
        $(this).prepend('<div class="svg-container"></div>')
         var url = $(this).attr('href');
         var container = $(this).parent().find('.svg-container');
         checkAndDisplaySVG(url, container);
        
    })
}